import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { SegmentoActivo } from '../_models/segmento-activo';

@Injectable({
  providedIn: 'root'
})
export class SegmentoActivoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/segmentosActivos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as SegmentoActivo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as SegmentoActivo[] ) );
  }

  obtenerPorSegmento( idSegmento: string ) {
    return this.httClient.get( this.rutServicio + '/segmento/' + idSegmento ).pipe( map( res => res as SegmentoActivo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as SegmentoActivo ) );
  }

  agregar( regCrear: SegmentoActivo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegmentoActivo ) );
  }

  actualizar( regActualizar: SegmentoActivo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as SegmentoActivo ) );
  }

}
